import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-error"
}
const _hoisted_2 = { class: "w-100 d-flex justify-center mt-6" }

import { ref, computed, onMounted } from 'vue';
import { getArticlesByType } from '@/services/news/article.service';
import { ArticleListItem } from '@/services/news/article.model';
import ArticleCard from '@/components/ArticleCard/ArticleCard.vue';

const itemsPerPage = 5;

export default /*@__PURE__*/_defineComponent({
  __name: 'DrUniversityHome',
  setup(__props) {

const articles = ref<ArticleListItem[]>([]);
const currentPage = ref(1);
const loading = ref(true);
const errorMessage = ref<string | null>(null);

const totalPages = computed(() => Math.ceil(articles.value.length / itemsPerPage));

const paginatedArticles = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  return articles.value.slice(start, start + itemsPerPage);
});

async function fetchArticles() {
  try {
    loading.value = true;
    const res = await getArticlesByType('DR University');
    articles.value = res;
  } catch (err) {
    console.error('Error loading articles:', err);
    errorMessage.value = 'Failed to load DR University articles.';
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  fetchArticles();
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "py-6 d-flex flex-column align-center ga-4" }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "d-flex mx-auto my-6"
          }))
        : (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(errorMessage.value), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedArticles.value, (article) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: article.id,
                  class: "w-100 d-flex justify-center"
                }, [
                  _createVNode(ArticleCard, {
                    title: article.title,
                    shortDescription: article.shortDescription,
                    links: article.links,
                    image: article.image,
                    slug: article.slug,
                    createdAt: article.createdAt
                  }, null, 8, ["title", "shortDescription", "links", "image", "slug", "createdAt"])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_2, [
                (totalPages.value > 1)
                  ? (_openBlock(), _createBlock(_component_v_pagination, {
                      key: 0,
                      modelValue: currentPage.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                      length: totalPages.value,
                      "total-visible": "5",
                      class: "pagination"
                    }, null, 8, ["modelValue", "length"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
    ]),
    _: 1
  }))
}
}

})